import { LanguageService } from './language.service';
var LanguagePipe = (function () {
    function LanguagePipe(_language) {
        this._language = _language;
    }
    LanguagePipe.prototype.transform = function (value, args) {
        return this._language.getTranslation(value);
    };
    return LanguagePipe;
}());
export { LanguagePipe };
